module.exports = __webpack_public_path__ + "static/media/home6.c3a302fa.jpg";